<template>
	<nav class="breadcrumbs">
		<ul>
			<li v-for="(breadcrumb, index) in breadcrumbs" :key="index">
				<router-link
					v-if="index !== breadcrumbs.length - 1"
					:to="breadcrumb.link"
					class="breadcrumb-link"
				>
					{{ breadcrumb.name }}
				</router-link>
				<span v-else class="breadcrumb-current">
					{{ breadcrumb.name }}
				</span>
				<span
					v-if="index !== breadcrumbs.length - 1"
					class="breadcrumb-separator"
					>/</span
				>
			</li>
		</ul>
	</nav>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const breadcrumbs = computed(() => {
	const pathArray = route.path.split("/").filter((p) => p);

	const breadcrumbList = pathArray.map((pathPart, index) => {
		const link = "/" + pathArray.slice(0, index + 1).join("/");
		return {
			name: beautifySlug(decodeURIComponent(pathPart)),
			link: link,
		};
	});

	return breadcrumbList;
});

// 👇 Den här funktionen fixar till sluggar till läsbara namn
function beautifySlug(slug: string) {
	return slug
		.split("-") // Dela på bindestreck
		.map((word) => {
			if (word.toLowerCase() === "d") return "d'"; // Hantera franska "d'"
			return capitalize(word);
		})
		.join(" ")
		.replace("D' ", "D'"); // Snygga till mellanrum efter D'
}

function capitalize(str: string) {
	if (!str) return "";
	return str.charAt(0).toUpperCase() + str.slice(1);
}
</script>

<style scoped>
.breadcrumbs {
	font-size: 0.95rem;
	color: #007bff;
}

.breadcrumbs ul {
	list-style: none;
	padding: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}

.breadcrumbs li {
	display: flex;
	align-items: center;
}

.breadcrumb-link {
	color: #007bff;
	text-decoration: none;
	font-weight: 500;
}

.breadcrumb-link:hover {
	text-decoration: underline;
}

.breadcrumb-current {
	color: #007bff;
	text-decoration: underline;
}

.breadcrumb-separator {
	margin: 0 0.5rem;
	color: #007bff;
}
</style>
